import { render, staticRenderFns } from "./ComOrderWaitTM.vue?vue&type=template&id=0172a9b3&scoped=true&"
import script from "./ComOrderWaitTM.vue?vue&type=script&lang=js&"
export * from "./ComOrderWaitTM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0172a9b3",
  null
  
)

export default component.exports